import script from "./AnswerResultPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnswerResultPage.vue?vue&type=script&setup=true&lang=ts"

import "./AnswerResultPage.vue?vue&type=style&index=0&id=0d29dfd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d29dfd2"]])

export default __exports__